export const GET_VACANCIES = 'vacancies/GET_VACANCIES';



// WEBPACK FOOTER //
// ./src/redux/Vacancies/constants.js